import { render, staticRenderFns } from "./KakaoButton.vue?vue&type=template&id=3ef5e264"
import script from "./KakaoButton.vue?vue&type=script&lang=js"
export * from "./KakaoButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports